<template>
  <vtms-modal
    unique="update-crew-certificate"
    :title="`UPDATE ${crewTraining.courseName} CERTIFICATE`"
    size="lg"
  >
    <form @submit.prevent="confirmUpdateCrewTrainingCertificate">
      <div class="form-group form-row mt-2">
        <label
          class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
          for="certificate-number"
        >Certificate Number:</label>
        <div class="col col-sm-5">
          <input
            type="text"
            id="certificate-number"
            v-model="certificateNumber"
            class="form-control form-control-xs form-control-xxs"
          >
        </div>
        <div class="col col-sm-3">
          <button
            type="submit"
            class="btn btn-sm btn-xs btn-warning font-weight-bolder my-auto"
          >
            <span class="fas fa-edit" />
            Update
          </button>
        </div>
      </div>
    </form>
  </vtms-modal>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { formMixins } from "@/mixins/formMixins";

import VtmsModal from "@/components/elements/VtmsModal";

export default {
  name: "UpdateCrewTrainingCertificate",

  mixins: [ formMixins ],

  components: {
    VtmsModal
  },

  props: {
    crewTraining: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  data() {
    return {
      certificateNumber: ''
    }
  },

  methods: {
    ...mapActions([
        'updateCrewTrainingCertificate'
    ]),

    async confirmUpdateCrewTrainingCertificate() {
      if(await this.confirmUpdateAlert()) {
        let params = {
          crewTrainingId: this.crewTraining.crewTrainingId,
          certificateNumber: this.certificateNumber
        };
        let updatedCertificateNumber = await this.updateCrewTrainingCertificate(params);
        if(updatedCertificateNumber) {
          this.successAlert('Certificate Number Successfully Updated', 'UPDATE');
        } else {
          this.errorAlert('Failed to Update Certificate Number', 'UPDATE RECORD')
        }
      }
    }

  },

  computed: {
    ...mapGetters([
    ]),
  },

  watch: {
    'crewTraining'() {
      this.certificateNumber = this.crewTraining.certificateNumber;
    }
  }

}
</script>

<style scoped>

</style>